import React, {useEffect, useState} from 'react';
import {Redirect} from 'react-router-dom';
import {connect} from "react-redux";
import {
    getAssetByCode,
    getAssetByCodeSl
} from "../../appRedux/actions/Asset";
import {Spin} from "antd";

const mapStateToProps = ({commonData, auth, asset}) => {
    return {
        // will be available as props.trips
        loading: commonData.loading,
        authUser: auth.authUser,
        asset: asset.assetFromCode,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        getAssetByCode,
        getAssetByCodeSl
    }
}

function QrRedirect(props) {
    const [uriData, setUriData] = useState(null)
    const [allowToRedirect, setAllowToRedirect] = useState(false)
    const [assetDoc, setAssetDoc] = useState(null)

    useEffect(() => {
        const {location} = props;
        const params = new URLSearchParams(location.search);
        const organisation = params.get('organizationId');
        const assetCode = params.get('assetCode');
        setUriData({
            organisation, assetCode
        })
    }, []);

    useEffect(() => {
        const {assetCode} = uriData || {}
        if (assetCode)
            props.getAssetByCodeSl(assetCode);
    }, [uriData]);

    useEffect(() => {
        if (props.asset) {
            const {assetCode, organisation: org} = uriData || {}
            const {data: asset} = props.asset || {};
            const {organisation} = props.authUser || {}
            const [code, no] = assetCode.split(',');
            const [_code, _no] = (asset.assetCode || '').split(',');
            setAllowToRedirect(!!(asset && assetCode && org && organisation && asset.assetCode && asset.organisation &&
                no === _no && org.toString() === organisation._id.toString() &&
                organisation._id.toString() === asset.organisation.toString()))
            setAssetDoc(asset);
            // console.log(no, _no)
            // console.log(no === _no)
            // console.log(org.toString() === organisation._id.toString())
            // console.log(organisation._id.toString() === asset.organisation.toString())
        }
    }, [props.asset]);

    return (
        <div>
            <Spin spinning={props.loading}>
                {(allowToRedirect && assetDoc) && <Redirect to={`history-report/${assetDoc._id}`}/>
                    /*<Alert message="Error" type="error" showIcon description="Something went wrong!."/>*/}
            </Spin>
        </div>
    );
}

export default connect(mapStateToProps, mapDispatchToProps())(QrRedirect);
